<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
                    <slot name="header">
                        <!-- <h3 class="form-header">{{ actionTitle }}</h3> -->
                        <h3 class="form-header">
                            {{ accessCode && !actionTitle ? 'Access Code Required' : (actionTitle || 'Response') }}
                        </h3>
                        <button @click="closeModal" class="red-close-button">
                            <i class="pi pi-times" style="padding: 0;"></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        <i v-if="loading" class="pi pi-spin pi-spinner"
                            style="font-size: 2rem !important; margin-top: 10px; margin-bottom: 10px;">
                        </i>


                        <div v-else-if="additionalFilterStatus && !loading"
                            class="action-description date-range-container">
                            <div class="date-selector">
                                <label for="from-date">From Date:</label>
                                <input type="date" id="from-date" v-model="from" @input="validateDates">
                            </div>
                            <div class="date-selector">
                                <label for="to-date">To Date:</label>
                                <input type="date" id="to-date" v-model="to" @input="validateDates">
                            </div>
                        </div>

                        <div v-else-if="accessCode && !errorMessage && !loading" class="action-description"
                            style="display: flex; flex-direction: column; align-items: flex-start; gap: 8px;">
                            <span style="font-size: 12px; color: #666; font-weight: 600;">Access Code</span>
                            <input v-model="inputAccessCode" type="text" placeholder="Enter access code"
                                style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px;">
                        </div>

                        <div v-else-if="uploadFile && !errorMessage && !loading" class="action-description"
                            style="display: flex; flex-direction: column; align-items: flex-start; gap: 8px;">

                            <span style="font-size: 12px; color: #666; font-weight: 600;">Please select the following
                                options</span>


                            <div style="display: flex; gap: 0px; align-items: center;  margin: 0 0 0 30px; "
                                class="administrations-search">
                                <Button v-if="!this.supersedeFile" @click="setActionType('print')"
                                    style="width: fit-content; margin-right: 10px;"
                                    class="outline-button p-button-outlined" label="Print Only"
                                    :style="actionType === 'print' ? 'background-color: #007BFF; color: white !important;' : 'background-color: #ffffff; color: grey !important;'" />
                                <Button v-if="!this.supersedeFile" @click="setActionType('upload')"
                                    style="width: fit-content;  margin-right: 10px;"
                                    class="outline-button p-button-outlined" label="Upload to MHR"
                                    :style="actionType === 'upload' ? 'background-color: #007BFF; color: white !important;' : 'background-color: #ffffff; color: grey !important;'" />
                                <Button v-if="this.supersedeFile" @click="setActionType('upload')"
                                    style="width: fit-content;  margin-right: 10px;"
                                    class="outline-button p-button-outlined" label="Upload New File"
                                    :style="actionType === 'upload' ? 'background-color: #007BFF; color: white !important;' : 'background-color: #ffffff; color: grey !important;'" />
                                <Button v-if="this.supersedeFile" @click="setActionType('supersede')"
                                    style="width: fit-content; margin-right: 20px;"
                                    class="outline-button p-button-outlined" label="Overwrite Existing File"
                                    :style="actionType === 'supersede' ? 'background-color: #007BFF; color: white !important;' : 'background-color: #ffffff; color: grey !important;'" />
                            </div>

                            <!-- <div v-if="actionType === 'print'" class="action-description"
                                style="display: flex; flex-direction: column; align-items: flex-start; gap: 8px;">
                            </div> -->
                            <div v-if="actionType === 'upload'" class="action-description"
                                style="display: flex; flex-direction: column; align-items: flex-start; gap: 8px;">
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <input type="checkbox" id="uploadCheckbox" v-model="uploadChecked">
                                    <label for="uploadCheckbox">I agree to give this facility access to
                                        upload {{ $resident() }} medication charts to my health record (MHR).</label>
                                </div>
                            </div>
                        </div>

                        <p v-else-if="!loading && !errorMessage" class="action-description">
                            {{ actionDescription }}
                        </p>

                        <p style="color: red;" v-else>
                            {{ errorMessage }}
                        </p>

                    </slot>
                </div>

                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px;">
                    <slot name="footer" style="display: flex;">

                        <p v-if="!hideCancel" class="red-button" style="color: white; margin-right: 10px;" @click="closeModal()">
                            {{ rejectText ? rejectText : 'Cancel' }}
                        </p>
                        <p v-if="accessCode && !loading" style="color: white; margin-right: 10px;"
                            class="regular-button black-button" @click="acceptAction('emergencyAccess')">
                            Emergency Access
                        </p>
                        <div v-if="uploadFile && !loading && !errorMessage">
                            <!-- <p class="regular-button green-button" @click="acceptAction()">
                                {{ acceptText ? acceptText : 'Confirm' }}
                            </p> -->
                            <button class="regular-button green-button" @click="acceptAction()"
                                :class="{ 'disabled-button': actionType === 'upload' && !uploadChecked }"
                                :disabled="actionType === 'upload' && !uploadChecked">
                                {{ acceptText ? acceptText : 'Confirm' }}
                            </button>
                        </div>
                        <p v-else-if="!loading && !errorMessage" class="regular-button green-button" @click="acceptAction()">
                            {{ acceptText ? acceptText : 'Confirm' }}
                        </p>

                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['actionDescription', 'rejectText', 'acceptText', 'loading', 'errorMessage', 'actionTitle', 'accessCode', 'uploadFile', 'removeFile', 'additionalFilterStatus', 'supersedeFile', 'hideCancel'],
    emits: ['close', 'action'],
    data() {
        return {
            inputAccessCode: '',
            actionType: 'print',
            uploadChecked: false,
            from: '',
            to: ''
        }
    },
    methods: {
        validateDates() {
            if (this.from && this.to && this.from > this.to) {
                const temp = this.from;
                this.from = this.to;
                this.to = temp;
            }
        },
        closeModal() {
            console.log('hitting this closemodal function')
            this.$emit('close', true);
        },
        acceptAction(type) {
            if (this.uploadFile) {
                const action = {
                    type: this.actionType,
                    file: this.supersedeFile?.documentId
                };
                // also pass in selected file here this.supersedefile
                this.$emit('action', action);
            } else if (this.accessCode) {
                console.log("accepting action .....");
                // generic action - can take payload or not depend on parent "action" fn
                const payload = {
                    access_type: type === "emergencyAccess" ? "emergencyAccess" : "AccessCode",
                    access_code: this.inputAccessCode
                };
                this.$emit('action', payload);
            } else if (this.additionalFilterStatus) {
                const payload = {
                    from: this.from,
                    to: this.to
                };
                console.log("this is date fitler ", payload);
                this.$emit('action', payload);
            } else if (this.removeFile) {
                this.$emit('action');
            } else {
                this.$emit('action');
            }
        },
        setActionType(actionType) {
            this.actionType = actionType
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";

.action-description {
    white-space: pre-wrap;
    text-align: left;
    font-size: 16px;
}

.modal-body {
    padding-left: 20px;
}

.modal-container {
    min-width: 480px;
    width: 20%;
}

.disabled-button {
    opacity: 0.5;
    cursor: not-allowed;
}

.date-range-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    width: 100%;
}

.date-selector {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.date-selector label {
    margin-bottom: 5px;
    font-weight: bold;
}

.date-selector input {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 100%;
}
</style>
